import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { NotificationFullData } from "../../layout/UserNotification";
import { contentStyles, titleStyles, wrapperStyles } from "./BookingStarted";
import useThemeStore from "../../services/store/useThemeStore";
import { DateNTime } from "../../utils/dateTime";
import { useTranslation } from "react-i18next";

const buttonStyles = (darkMode: boolean) => ({
  background: darkMode ? "var(--button-gradient)" : "var(--button-gradient)",
  color: darkMode ? "var(--neutralWhite)" : "var(--neutralWhite)",
  textTransform: "none",
  font: "var(--semibold-xxs)",
  padding: "var(--spacing-4x)",
  boxShadow: "none",
  minWidth: "85px",
  borderRadius: "8px !important",
  "&:hover": {
    background: darkMode
      ? "var(--button-gradient-hover)"
      : "var(--button-gradient-hover)",
  },
});

const CoffeeCallStarted = ({
  notification,
}: {
  notification: NotificationFullData;
}) => {
  const navigate = useNavigate();
  const { darkMode } = useThemeStore();
  const { t } = useTranslation();

  return (
    <Box sx={wrapperStyles(darkMode)}>
      <Box sx={contentStyles}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography sx={titleStyles(darkMode)}>
            {t("coffee_call_started", { ns: "notification" })}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            sx={buttonStyles(darkMode)}
            onClick={() =>
              navigate(`/coffee-call/${notification?.data?.channel_name}`)
            }
          >
            {t("join_call")}
          </Button>
        </Box>
        <Typography
          sx={{
            color: darkMode ? "var(--neutral-300)" : "var(--neutral-500)",
            font: "var(--body-xs)",
            fontWeight: 400,
          }}
        >
          {notification?.data?.username}{" "}
          {t("has_started_the_coffee_call", { ns: "notification" })}{" "}
          {t("please")}
          {t("join_call")}.
        </Typography>
        {notification?.created_at && (
          <Typography
            sx={{
              font: "var(--semibold-xxs)",
              color: darkMode ? "#9ca3af" : "#64748b",
              fontWeight: 500,
            }}
          >
            {DateNTime.formatRelative(notification.created_at)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default CoffeeCallStarted;
